import styled from '@emotion/styled';
import MUIDataTable from 'mui-datatables';

import type { MUIDataTableProps } from 'mui-datatables';

interface FHMUIDataTableProps extends MUIDataTableProps {
  containerStyles: any;
}

const StyledMUIDataTable = styled(MUIDataTable, {
  shouldForwardProp: (prop) =>
    prop !== 'colorTheme' && prop !== 'coloredBackground' && prop !== 'rowGap',
})<FHMUIDataTableProps>(({ containerStyles }: any) => ({
  '&.MuiPaper-root': {
    ...containerStyles,
  },
  '& .MuiTableCell-root': {
    padding: '20px 17px',
  },
}));

const FHMUIDataTable = (props: FHMUIDataTableProps) => {
  return <StyledMUIDataTable {...props} />;
};
export default FHMUIDataTable;
